import React, { ReactElement } from 'react';
import { ServerSideInitProps } from 'types/types';
import { getData } from 'utils/helpers/server/serverSideData';
import CoachesPage from 'components/pages/coach/list/CoachesPage';
import {
    EMPTY_PAGINATOR,
    PaginatorPageInterface,
} from 'components/interfaces/Paginator';
import {
    CoachListApiInterface,
    PaginatorInterface,
} from 'submodules/api_middleware';
import { getGlobalProps } from 'utils/helpers/server/serverSideProps/global';
import { getPageProps } from 'utils/helpers/server/serverSideProps/ssrProps';
import { Option } from 'components/interfaces/GeneralInterface';
import { getPageNamespaces } from 'utils/helpers/server/serverSideProps/translations';
import { czechRegionOptions } from 'constants/regions';
import {
    isCoachesRequestAllowed,
    isCoachesPublicRequest,
} from 'utils/helpers/server/coachesAccess';
import { serverRedirect } from 'utils/helpers/server/serverRedirect';

interface Props extends PaginatorPageInterface {
    coaches: CoachListApiInterface[];
    regionList: Option[];
}

interface ServerSideProps {
    props?: Props;
}

const Page = ({ coaches, paginator, regionList }: Props): ReactElement => {
    return (
        <CoachesPage
            coaches={coaches}
            paginator={paginator}
            regionList={regionList}
        />
    );
};

export const getServerSideProps = async ({
    req,
    res,
    query,
}: ServerSideInitProps): Promise<ServerSideProps> => {
    // TODO: po otestování na produkci smazat – na public hostu povolit i nepřihlášené.
    const { api } = await getGlobalProps(req, res, isCoachesPublicRequest(req));

    // TODO: tento if po otestování na produkci Smazat.
    if (!isCoachesRequestAllowed(req, res)) {
        serverRedirect('/home', res);
        return {};
    }
    const response = await getData<{
        data: CoachListApiInterface[];
        meta: PaginatorInterface;
    }>(res, req, api.coach().coachList(query));

    const coaches = response?.data ?? [];
    const paginator = response?.meta ?? EMPTY_PAGINATOR;

    const props = await getPageProps<Props>({
        givenProps: {
            paginator,
            coaches,
            regionList: czechRegionOptions,
        },
        req,
        res,
        api,
        query,
        nameSpaces: getPageNamespaces('/coaches'),
    });

    return {
        props,
    };
};

export default Page;
